export var PDF_PAGE_WIDTH = 595.28;
export var PDF_PAGE_HEIGHT = 841.89;
export var PDF_PAGE_CONTENT_COMMON_PADDING = 12;
export var PDF_PAGE_ROW_LINE_HEIGHT = 12;
export var PDF_PAGE_ROW_PADDING_Y = 6;
export var PDF_PAGE_ROW_FONT_SIZE = 10;